/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import { ALGO_LIST_TABLE_SETTINGS_SAVE_COLUMN_TOGGLE } from '../../constants/ActionTypes';
import storage from '../../storage';
import { columns } from '../../partials/AlgosList/Algotable/columns';

export const COLUMN_TOGGLE_COOKIE = 'algos-list-table-settings-column-toggle';

export function getColumnToggleCookie() {
  const cookie = storage.getItem(COLUMN_TOGGLE_COOKIE) || {};
  const newCookie = {};

  for (let index = 0; index < columns.length; index++) {
    const column = columns[index];

    if (!column?.meta?.toggle) {
      continue;
    }

    let cookieData = cookie[column.accessor];

    if (cookieData === undefined) {
      // assign default state
      cookieData = column?.meta?.toggleDefaultState || false;
    }

    newCookie[column.accessor] = cookieData;
  }

  return newCookie;
}

function getInintialColumnToggleData() {
  const cookie = getColumnToggleCookie();
  const toggleColumns = [];

  for (let index = 0; index < columns.length; index++) {
    const column = columns[index];

    if (!column?.meta?.toggle) {
      continue;
    }

    const cookieData = cookie[column.accessor] || false;
    let label = column.accessor;

    if (column.HeaderSimple) {
      label = column.HeaderSimple;
    } else if (column.Header && typeof column.Header == 'string') {
      label = column.Header;
    } else {
      label = column.accessor;
    }

    toggleColumns.push({
      name: column.accessor,
      label: label,
      showColumn: cookieData,
    });
  }

  return toggleColumns;
}

function convertToCookieData(arrayData = []) {
  const toggleColumns = {};

  for (let index = 0; index < arrayData.length; index++) {
    const element = arrayData[index];

    toggleColumns[element.name] = element.showColumn;
  }

  return toggleColumns;
}

const columnToggle = (
  state = {
    data: getInintialColumnToggleData(),
    updateTime: Date.now(),
  },
  action
) => {
  switch (action.type) {
    case ALGO_LIST_TABLE_SETTINGS_SAVE_COLUMN_TOGGLE:
      storage.setItems({
        [COLUMN_TOGGLE_COOKIE]: convertToCookieData(action.data),
      });

      return {
        ...state,
        updateTime: Date.now(),
        data: action.data,
      };
    default:
      return state;
  }
};

const algosListTableSettings = combineReducers({
  columnToggle,
});

export default algosListTableSettings;
